
import { defineComponent, ref, watchEffect, onMounted } from 'vue';
import { Apollo } from '@/core/services';
import { useStore } from 'vuex';
import { GET_SUBSCRIPTION_ORDER_LISTS } from '../../../modules/order/graphql/Queries';
import { useI18n } from 'vue-i18n';
import Table from '../../Table/Table.vue';
import { useRouter } from 'vue-router';
import InnerLoader from '../../InnerLoader.vue';

export default defineComponent({
    name: 'Orders',
    components: {
        Table,
        InnerLoader
    },
    setup() {
        const store = useStore();
        const i18n = useI18n();
        const loader = ref(false);
        const orders: any = ref([]);
        const system_locale = ref();
        const router = useRouter();
        const permissions = store.getters.getPermissions;
        const pagination = ref({}) as Record<any, any>;
        const clickHandler = ref() as Record<any, any>;

        const columns = ref([
            {
                label: 'message.CUSTOMERS',
                key: 'name'
            },
            {
                label: 'message.TENURE',
                key: 'tenure'
            },
            {
                label: 'message.STATUS',
                key: 'status'
            },
            {
                label: 'message.ORIGIN',
                key: 'origin'
            },
            // {
            //     label: 'message.SHIPMENT',
            //     key: 'shipment'
            // },
            // {
            //     label: 'message.TOTAL',
            //     key: 'total',
            //     textAlignment: 'end'
            // },
            {
                label: 'message.LAST_ORDER_DATE',
                key: 'last_order_date'
            },
            {
                label: 'message.NEXT_ORDER_DATE',
                key: 'next_order_date'
            },
            {
                label: 'message.CREATED_AT',
                key: 'created_at'
            },
            {
                label: 'message.ACTIONS',
                key: 'actions',
                textAlignment: 'center'
            }
        ]);

        watchEffect(() => {
            system_locale.value = i18n.fallbackLocale.value;
        });

        const Orders = (page = 0) => {
            loader.value = true;
            Apollo.watchQuery({
                query: GET_SUBSCRIPTION_ORDER_LISTS,
                errorPolicy: 'all',
                fetchPolicy: 'network-only',
                nextFetchPolicy: 'cache-only',
                variables: {
                    page: page,
                    limit: 10
                }
            }).subscribe(({ data, errors }) => {
                if (errors) {
                    loader.value = false;
                }

                orders.value = data?.orders_subscription?.data || [];
                pagination.value = data.orders_subscription;
                clickHandler.value = Orders;
                loader.value = false;
            });
        };

        onMounted(() => {
            Orders();
        });

        // Function to convert YYYY-MM-DD to DD-MM-YYYY
        const formatToDdMmYyyy = ymdDate => {
            const parts = ymdDate.split('-');
            if (parts.length === 3) {
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            return ymdDate; // return original if format doesn't match
        };

        const timestampToDateOnly = timestamp => {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            return `${day}-${month}-${year}`; // Returns "YYYY-MM-DD" format
        };

        const handleCurrentChange = page_number => {
            clickHandler.value(page_number);
        };

        const lastOrderplaced = dateString => {
            if (dateString === 'send') {
                return '🟢'; // date found in subscription history
            }

            return '🔴'; // default if date format is invalid
        };

        const handleView = (order: Record<any, any>) => {
            router.push({ name: 'subscription_detail', params: { uuid: order.uuid } });
        };

        return {
            orders,
            system_locale,
            columns,
            permissions,
            handleView,
            loader,
            lastOrderplaced,
            formatToDdMmYyyy,
            timestampToDateOnly,
            pagination,
            handleCurrentChange,
            clickHandler
        };
    }
});
